<template>
    <div id="badge-alert-wrapper-component">
        <div @click="openAlertDialog()">
            <BadgeAlertComponent :alert="alert" />
        </div>

        <AddEditAlertFormDialogComponent
            v-if="userHasAccess('BASE', this.role_edit)"
            ref="addEditAlertFormDialog"
            data-cy="add-edit-alert-form-dialog-component"
            v-on:refresh:alert="refreshAlert"
        />

        <AcquitAlertFormDialogComponent ref="acquitAlertFormDialog" v-on:refresh:alert="refreshAlert" />
    </div>
</template>

<script>
import BadgeAlertComponent from '@/components/alert/containment/BadgeAlertComponent.vue'
import AddEditAlertFormDialogComponent from '@/components/alert/form/AddEditAlertFormDialogComponent.vue'
import { EmptyAlert } from '@/models/IAlert'
import AcquitAlertFormDialogComponent from '@/components/alert/form/AcquitAlertFormDialogComponent.vue'

export default {
    name: 'BadgeAlertWrapperComponent',
    components: { AcquitAlertFormDialogComponent, BadgeAlertComponent, AddEditAlertFormDialogComponent },
    props: {
        alert: {
            type: Object,
            required: true,
            default: EmptyAlert,
        },
    },
    methods: {
        openAlertDialog() {
            if (this.alert.triggered) {
                this.$refs.acquitAlertFormDialog.openDialogAcquitAlert(this.alert)
            } else {
                this.$refs.addEditAlertFormDialog.openDialogEditAlert(this.alert)
            }
        },
        refreshAlert() {
            this.$emit('refresh:alert')
        },
    },
}
</script>